import {render} from 'react-dom';
import {ConfigProvider} from 'antd';
import track from '@baidu/bce-track';
import dayjs from 'dayjs';
import utc from 'dayjs/plugin/utc';
import timezone from 'dayjs/plugin/timezone';
import quarterOfYear from 'dayjs/plugin/quarterOfYear';
import 'dayjs/locale/zh-cn';

import * as Weirwood from '@baidu/weirwood-sdk';
import '@/styles';

// App 组件必现使用懒加载的方式，否则国际化渲染可能会出错。
// 以汉字 "产品名称" 为例，在编译阶段会被替换为 i18n('产品名称')
// const productName = '产品名称' 会被编译为 const productName = i18n('产品名称')
// 非懒加载的方式，定义在常量之类文件的这种代码会直接执行。此时国际化语料包还没完成加载，所以会导致出错。
import App from '@/components/App/Lazy';

import {setConstants, setFlags, setRegion, setSession} from '@/common/framework';

import weirwoodConfig from '@/config/weirwood';
import {getLanguage, initI18n} from '@/common/i18n';

const initFramework = async () => {
    window.framework.boot().then(async initData => {
        // 保存 framework 初始化常量
        setConstants(initData?.constants);
        setFlags(initData?.flag);
        setRegion(initData?.region);
        setSession(initData?.session);

        await initI18n();

        const root = document.getElementById('main');
        render(<App {...initData} />, root);

        // regionSwitchHandler 是 APP 处理 Region 切换之后逻辑的函数
        window.framework.events.on(window.framework.EVENTS.AFTER_REGION_CHANGED, (e: { data: any }) => {
            initData.region.id = e.data;
            setRegion(initData?.region);
            render(<App {...initData} />, root);
        }, this);
    });
};

const initDayJs = () => {
    dayjs.locale(getLanguage());
    dayjs.extend(utc);
    dayjs.extend(timezone);
    dayjs.extend(quarterOfYear);
};

initDayJs();

track.install({
    uploadUrl: '/api/log/csi',
    autoTrack: true,
    limit: 1,
} as any);

initFramework();

Weirwood.init(weirwoodConfig);


// 设置 Modal、Message、Notification rootPrefixCls
// https://4x.ant.design/components/config-provider-cn/#ConfigProvider.config()-4.13.0+
ConfigProvider.config({prefixCls: 'idaas-ant'});
